import React from 'react';

interface BulkDeleteConfirmationProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  fileCount: number;
}

export default function BulkDeleteConfirmation({ 
  isOpen, 
  onClose, 
  onConfirm,
  fileCount 
}: BulkDeleteConfirmationProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Confirmare ștergere
        </h3>
        <p className="text-gray-600 mb-6">
          Sunteți sigur că doriți să ștergeți {fileCount} {fileCount === 1 ? 'document' : 'documente'}? 
          Această acțiune nu poate fi anulată.
        </p>
        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 hover:text-gray-900 transition"
          >
            Anulează
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
          >
            Șterge
          </button>
        </div>
      </div>
    </div>
  );
}